// Shim over the root AuthContext so legacy admin pages (ported from
// frontend/src) keep working without a second AuthProvider or process.env.
import { useAuth as useRootAuth } from '../AuthContext';

export const useAuth = () => {
  const state = useRootAuth();
  return { ...state, isAuthenticated: !!state.user };
};

export default useAuth;
